import { render, staticRenderFns } from "./RailwayDetails_Component.vue?vue&type=template&id=1dc84c98&scoped=true&"
import script from "./RailwayDetails_Component.vue?vue&type=script&lang=js&"
export * from "./RailwayDetails_Component.vue?vue&type=script&lang=js&"
import style0 from "./RailwayDetails_Component.vue?vue&type=style&index=0&id=1dc84c98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc84c98",
  null
  
)

export default component.exports